<div #body class="detail-page__body">
  <app-quick-nav #quicknav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <app-tfr-alert [airport]="airport"></app-tfr-alert>
  <app-airport-alert [airport]="airport"></app-airport-alert>
  <div class="airport-detail__before-overview">
    <app-edit-toggle *ngIf="isAirportManager; else nonManagerPlaceholder" class="editSlider"></app-edit-toggle>
    <app-airport-flight-deck-button *ngIf="editModeSet && isFlightDeckAdmin" [airport]="airport"></app-airport-flight-deck-button>
    <div class="airport-detail__faa-text">
      <p><b>FAA Information Effective: {{ airport.dataEffectiveDate | date: 'mediumDate' }}</b></p>
      <p>All information is provided from the FAA unless otherwise noted.</p>
    </div>
  </div>
  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div class="scroll-spy-section detail-page__wrapper" id="overview">
        <app-airport-overview [airport]="airport" [isSubscribedToIslandGuide]="false"></app-airport-overview>
      </div>
      <div class="detail-page__main">
        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="2" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="fbos">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text" *ngIf="sortedFBOs.length > 0; else noFBOPlaceholder">FBOs</h2>
              <button id="addFBOs"
                      mat-mini-fab
                      *ngIf="editModeSet && isFlightDeckAdmin"
                      (click)="openAddDialog('BUSINESS')">
                <mat-icon aria-label="Add FBO">add</mat-icon>
              </button>
              <div class="airport-detail__add-business"
                   *ngIf="!isFlightDeckAdmin"
                      (click)="openSubmitNewBusinessDialog('FBO')">Submit New FBO
              </div>
            </div>
            <div class="section__body">
              <app-business-listing [businesses]="airport.businesses" [airport]="airport" [fteAwardYear]="airport.fteAwardYear"></app-business-listing>
            </div>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="local">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">AOPA Travel Discounts
                <div><img src="assets/images/PoweredbyFlightBridge.png" width="150" height="16" alt="Powered by FlightBridge"></div>
                <!-- <div class="airport-detail__flightbridge-subtext">Powered by <span class="airport-detail__flightbridge-subtext-name">FlightBridge</span></div> -->
              </h2>
            </div>
            <div class="section__body">
              <app-flightbridge [airport]="airport"></app-flightbridge>
            </div>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Local Food/Lodging/Activities</h2>
            </div>
            <div class="section__body">
              <app-local-panel [airport]="airport"></app-local-panel>
            </div>
          </div>
        </div>

        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="3" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="flyingclubs">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Flying Clubs</h2>
              <button id="addFlyingClubs"
                      mat-mini-fab
                      *ngIf="editModeSet && isFlightDeckAdmin"
                      (click)="openAddDialog('FLYING CLUB')">
                <mat-icon aria-label="Add Flying Club">add</mat-icon>
              </button>
              <div class="airport-detail__add-business"
                   *ngIf="!isFlightDeckAdmin"
                   (click)="openSubmitNewBusinessDialog('Flying Club')">Submit New Flying Club
              </div>
            </div>
            <div class="section__body">
              <app-flyingclub-listing [flyingClubs]="airport.flyingClubs"></app-flyingclub-listing>
            </div>
          </div>
        </div>

        <!-- commented out temporarily per Eric on 3/9/2018
        <div class=scroll-spy-section id="fees">
          <app-airport-fee-summary [businessSummaries]="businessesWithFees"></app-airport-fee-summary>
        </div> -->

        <div class="scroll-spy-section detail-page__wrapper" id="runways">
          <app-runway-listing [airport]="airport"></app-runway-listing>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="notams">
          <app-tfrs [airport]="airport" class="airport-detail__full-width"></app-tfrs>

          <app-notams [airport]="airport" class="airport-detail__full-width"></app-notams>

          <app-remarks class="airport-detail__full-width" [airport]="airport"></app-remarks>

          <app-noise-abatement [airport]="airport"></app-noise-abatement>
        </div>

        <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="4" [ident]="airport.faaId"></app-open-x-adunit>

        <div class="scroll-spy-section detail-page__wrapper" id="procedures">
          <app-procedure-listing class="section procedure-listing" [identifier]="airport.identifier"
                                 [procedurePack]="airport.terminalProcedures"></app-procedure-listing>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="operations">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Operations &amp; More Information</h2>
            </div>
            <div class="section__body">
              <app-operations [airport]="airport"></app-operations>
            </div>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="comms">
          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Communications Card</h2>
            </div>
            <div class="section__body">
              <app-communication-card [identifier]="airport.identifier"
                                      [flightComms]="airport.flightComms">
              </app-communication-card>
            </div>
          </div>

          <div class="section">
            <div class="section__header">
              <h2 class="section__header-text">Navaids</h2>
            </div>
            <div class="section__body">
              <app-navaid-listing [navaids]="airport.navaids" [identifier]="airport.identifier"></app-navaid-listing>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Services</h2>
          </div>
          <div class="section__body">
            <app-services [airport]="airport"></app-services>
          </div>
        </div>

        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Aircraft &amp; Activity</h2>
          </div>
          <div class="section__body">
            <app-airport-activity [activity]="airport.activity"></app-airport-activity>
          </div>
        </div>

        <div class="scroll-spy-section detail-page__wrapper" id="wx">
          <app-airport-webcams [airport]="airport" class="airport-detail__full-width"></app-airport-webcams>

          <div class="detail-page__wrapper">
            <app-metar-section [identifier]="airport.identifier" [latlon]="airport.location" [translated]="true"
                               class="section section--half-width"></app-metar-section>

            <app-taf-section [identifier]="airport.identifier" [latlon]="airport.location" [translated]="true"
                             class="section section--half-width"></app-taf-section>
          </div>
        </div>

        <!-- <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Air Safety Institute Resources</h2>
          </div>
          <div class="section__body section__content">
            <a [href]="'https://www.aopa.org/asf/ntsb/searchResults.cfm?identifier=' + airport.faaId + '&helicopter=BOTH'" target="_blank">
              Accident Reports
            </a>
          </div>
        </div> -->

        <div class="section">
          <div class="section__header">
            <h2 class="section__header-text">Contact Addresses</h2>
          </div>
          <div class="section__body">
            <app-contact-listing [contacts]="airport.contacts" [remarks]="airport.airportComments"></app-contact-listing>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-page__rail">
      <div class="detail-page__rail-content">

        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Airport Reviews</h2>
          </div>
          <div class="section__body">
            <app-reviews [airport]="airport" [business]=null (reloadThisEntity)="onReloadAirport($event)"></app-reviews>
          </div>
        </div>
      </div>

      <div class="detail-page__section-spacer"></div>

      <div class="detail-page__rail-content">

        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Nearby Events</h2>
          </div>
          <div class="section__body">
            <app-nearby-events [lat]="airport.location.lat" [lon]="airport.location.lon"></app-nearby-events>
          </div>
        </div>
      </div>

      <app-travel-articles [airportIdent]="airport.faaId"></app-travel-articles>

    </div>
  </div>
</div>

<ng-template #noFBOPlaceholder>
  <h2 class="section__header-text">FBOs and Other Businesses</h2>
</ng-template>

<ng-template #nonManagerPlaceholder>
  <p> </p>
</ng-template>
